import React, { Component } from "react";
import america from "../America";
import FeaturedItems from "../FeaturedItems";

export default class AmericaItems extends Component {
  render() {
    const America = america.map(item => (
      <FeaturedItems key={item.id} item={item} />
    ));
    return (
      <React.Fragment>
        <div className="america-parallax parallax d-flex justify-content-center align-items-center">
          <h1 className="main-photo-text">America</h1>
        </div>
        <div className="container">
          <div className="row mt-3 justify-content-md-center">{America}</div>
        </div>
      </React.Fragment>
    );
  }
}
